export default __webpack_public_path__ + "static/2040-1-a2c6a23a54bd3976aaa3e338be7cfc8f.jpg";